import React, { useEffect, useState, useCallback, useRef } from "react";
import googlemapIcon from "../../../assets/provider/images/Google_Map.svg";
import caresuccessful from "../../../assets/provider/images/successful.svg";
import TrashImg from "../../../assets/user/images/trash.svg";
import FileImg from "../../../assets/provider/images/file.jpg";
import deleteaccountImg from "../../../assets/user/images/delete-account.svg";
import { api } from "../../../utlis/provider/api.utlis";
import ApiService from "../../../core/services/ApiService";
import Loader from "../../../layouts/loader/Loader";
import NoImage from "../../../assets/admin/images/no-image.jpg";
import { Modal, ModalBody, ModalHeader } from "react-bootstrap";
import { Formik, Field, Form, ErrorMessage } from "formik";
import { useJsApiLoader, StandaloneSearchBox } from "@react-google-maps/api";
import {
  GeolocationApiKey,
  LogoFile,
  milesOptions,
  MultipleFile,
} from "../../../utlis/common.utlis";
import * as Yup from "yup";
import toast from "react-hot-toast";
import { Link, useNavigate } from "react-router-dom";
import { useDispatch } from "react-redux";
import { userLogout } from "../../../store/slices/Auth";
import LocImg from "../../../assets/user/images/location.svg";
import InputMask from "react-input-mask";
import Select from "react-select";
import { routes } from "../../../utlis/provider/routes.utlis";
import { updateProfileData } from "../../../store/slices/Profile";

const Page = () => {
  const options = [];
  const imgs = [];
  const editOptions = [];
  const stateArray = [];
  const cityOptions = [];
  const editCityOptions = [];
  const inputRef = useRef(null);
  const navigate = useNavigate();
  const dispatch = useDispatch();
  const [loading, setLoading] = useState(false);
  const [details, setDetails] = useState();
  const [cancelPlan, setCancelPlan] = useState({ status: false, id: null });
  const [deleteAcc, setDeleteAcc] = useState(false);
  //const [image, setImage] = useState([]);
  const [edit, setEdit] = useState({ status: false, id: null });
  const [editImg, setEditImg] = useState(false);
  const [state, setState] = useState([]);
  const [editState, setEditState] = useState([]);
  const [selectedState, setSelectedState] = useState([]);
  const [stateError, setStateError] = useState(false);
  const [city, setCity] = useState([]);
  const [editCity, setEditCity] = useState([]);
  const [selectedCity, setSelectedCity] = useState([]);
  const [cityError, setCityError] = useState(false);
  const [categories, setCategory] = useState([]);
  const [subCategories, setSubCategory] = useState([]);
  //const [selectRadius, setSelectRadius] = useState("");
  const [selectCategories, setSelectCategory] = useState("");
  //const [selectSubCategories, setSelectSubCategory] = useState("");
  const [selectedImages, setSelectedImages] = useState([]);
  const [selectedLicenseImages, setSelectedLicenseImages] = useState([]);
  const [selectedDeleteImages, setSelectedDeleteImages] = useState([]);
  //const [imgMultiError, setImgMultiError] = useState(false);
  const [location, setLocation] = useState({
    lat: null,
    lng: null,
    address: null,
  });

  const initialValues = {
    radius: details?.service_offered_area ?? "",
    category: findCategory(details?.category) ?? "",
    sub_category: details?.service_id ?? "",
    address: details?.business_address ?? "",
    name: details?.fullname ?? "",
    phone: details?.mobile ?? "",
    free_in_home_assessment:
      details?.free_in_home_assessment != null
        ? details.free_in_home_assessment.toString()
        : "",
    fee_per_week: details?.fee_per_week ?? "",
    fee_per_month: details?.fee_per_month ?? "",
    fee_per_hour: details?.fee_per_hour ?? "",
    business_name: details?.business_name ?? "",
    slogan: details?.slogan ?? "",
    license_number: details?.license_number ?? "",
    payment_accepted_type: details?.payment_accepted_type ?? "",
    response_time: details?.response_time ?? "",
    description: details?.description ?? "",
    experience: details?.experience ?? "",
    image: "",
    files: [],
  };

  const initialValuesImg = {
    image: "",
  };

  const validationSchema = Yup.object().shape({
    radius: Yup.string().required("Radius is required!"),
    category: Yup.string().required("Category is required!"),
    sub_category: Yup.string().required("Sub Category is required!"),
    address: Yup.string().required("Address is required!"),
    name: Yup.string().required("Name is required!"),
    phone: Yup.string()
      .min(14, "Phone is invalid")
      .required("Phone is required!"),
    free_in_home_assessment: Yup.string().required(
      "In-Home assessment is required!"
    ),
    business_name: Yup.string().required("Business name is required!"),
    slogan: Yup.string().required("Slogan is required!"),
    license_number: Yup.string()
      .matches(/^[A-Z0-9-]+$/, "Invalid license number format")
      .min(5, "License number must be at least 5 characters")
      .max(15, "License number must not exceed 15 characters")
      .required("License number is required!"),
    payment_accepted_type: Yup.string().required("Payment type is required!"),
    response_time: Yup.string().required("Response time is required!"),
    description: Yup.string().required("Services Description is required!"),
    experience: Yup.string().required("Experience is required!"),
    image: Yup.mixed()
      .test(
        "fileSize",
        `File size must be less than ${LogoFile} MB`,
        (value) => !value || (value && value.size <= LogoFile * 1024 * 1024)
      )
      .test("fileType", "Unsupported file type", (value) => {
        return value != "" && (value != null) & (value != undefined)
          ? ["image/jpeg", "image/png", "image/jpg"].includes(value.type)
          : true;
      }),
    files: Yup.array()
      .max(3, "You can upload a maximum of 3 images")
      .test("fileType", "Unsupported file type", (files) =>
        files.every((file) =>
          file.file != "" && (file.file != null) & (file.file != undefined)
            ? [
              "image/jpeg",
              "image/png",
              "image/jpg",
              "application/pdf",
              "application/vnd.openxmlformats-officedocument.wordprocessingml.document",
            ].includes(file.file.type)
            : true
        )
      )
      .test("fileSize", "File size is too large", (files) =>
        files.every((file) =>
          file.file != "" && (file.file != null) & (file.file != undefined)
            ? file.file.size <= MultipleFile * 1024 * 1024
            : true
        )
      ),
  });

  const validationSchemaImg = Yup.object().shape({
    image: Yup.mixed()
      .required("Please upload your profile image")
      .test("fileSize", "File size is too large", (value) => {
        return value && value.size <= LogoFile * 1024 * 1024;
      })
      .test("fileType", "Unsupported file type", (value) => {
        return (
          value && ["image/jpeg", "image/png", "image/jpg"].includes(value.type)
        );
      }),
  });

  const getCategoryList = async (api) => {
    const response = await ApiService.getAPI(api);
    // console.log("category list => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setCategory(response.data.data.categories);
    } else setCategory([]);
  };

  const getSubCategoryList = async (id) => {
    const response = await ApiService.getAPI(
      api.categoryList + `?categoryid=${id}`
    );
    // console.log("sub category list => ", response.data);
    if (response?.data?.status && response?.data?.statusCode === 200) {
      setSubCategory(response?.data?.data?.categories);
    } else setSubCategory([]);
  };

  const getStateList = async (api) => {
    const response = await ApiService.getAPI(api);
    // console.log("state list => ", response.data);
    if (response.data.status && response.data.statusCode === 200) {
      response.data.data.states.forEach((element) => {
        options.push({ value: element.id, label: element.name });
      });
      setState(options);
    } else setState([]);
  };

  const getCitiesList = async () => {
    let form = new FormData();
    selectedState.forEach((ele) => {
      form.append("state_ids[]", ele.value);
    });
    const response = await ApiService.postAPI(api.cityList, form);
    // console.log("cities list => ", response.data);
    if (response?.data?.status && response?.data?.statusCode === 200) {
      response.data.data.cities.forEach((element) => {
        cityOptions.push({ value: element.id, label: element.name });
      });
      setCity(cityOptions);
    } else setCity([]);
  };

  const getMyProfile = async (api) => {
    setLoading(true);
    const response = await ApiService.getAPIWithAccessToken(api);
    // console.log(response.data);
    if (response.data.status && response.data.statusCode === 200) {
      setSelectCategory(response?.data?.data?.categoryid);
      getSubCategoryList(response?.data?.data?.categoryid);
      setLocation({
        lat: response?.data?.data?.latitude,
        lng: response?.data?.data?.longitude,
        address: response?.data?.data?.business_address,
      });
      setDetails(response.data.data);
      dispatch(updateProfileData(response.data.data));
      response?.data?.data?.license_images.forEach((element) => {
        imgs.push({
          file: element,
          isLive: true,
          preview: element.url,
        });
      });
      response?.data?.data?.providerStates.forEach((element) => {
        editOptions.push({
          value: element.id,
          label: element.name,
        });
      });
      response?.data?.data?.providerStates.forEach((element) => {
        stateArray.push({
          value: element.id,
        });
      });
      response?.data?.data?.providerCities.forEach((element) => {
        editCityOptions.push({
          value: element.id,
          label: element.name,
        });
      });
      setEditState(editOptions);
      setEditCity(editCityOptions);
      setSelectedState(stateArray);
      setSelectedLicenseImages(imgs);
    } else setDetails();
    setLoading(false);
  };

  const updateProfile = async (formValue) => {
    setLoading(true);
    let form = new FormData();
    form.append("service_id", formValue.sub_category);
    form.append("fullname", formValue.name);
    form.append("phone", formValue.phone);
    form.append("description", formValue.description);
    form.append("fee_per_hour", formValue.fee_per_hour);
    form.append("fee_per_month", formValue.fee_per_month);
    form.append("fee_per_week", formValue.fee_per_week);
    form.append("experience", formValue.experience);
    form.append("business_name", formValue.business_name);
    form.append("slogan", formValue.slogan);
    form.append("license_number", formValue.license_number);
    form.append("free_in_home_assessment", formValue.free_in_home_assessment);
    form.append("service_offered_area", formValue.radius);
    form.append("payment_accepted_type", formValue.payment_accepted_type);
    form.append("response_time", formValue.response_time);
    form.append("business_address", location.address);
    form.append("latitude", location.lat);
    form.append("longitude", location.lng);
    if (selectedState.length !== 0) {
      selectedState.forEach((ele) => {
        form.append("state_ids[]", ele.value);
      });
    }
    if (selectedCity.length !== 0) {
      selectedCity.forEach((ele) => {
        form.append("city_ids[]", ele.value);
      });
    }
    if (formValue.files.length !== 0) {
      formValue.files.forEach((image) => {
        if (!image.isLive) form.append("license_image", image.file);
      });
    }
    if (selectedDeleteImages.length !== 0) {
      selectedDeleteImages.forEach((ele) => {
        form.append("deleteimageid[]", ele);
      });
    }
    if (formValue.image !== "" && formValue.image !== null && formValue.image) {
      form.append("file", formValue.image);
    }
    const response = await ApiService.putAPIWithAccessTokenMultiPart(
      api.updateProfile + edit.id,
      form
    );
    setSelectedImages([]);
    setSelectedDeleteImages([]);
    setSelectedLicenseImages([]);
    setEdit({
      status: false,
      id: null,
    });
    if (response.data.status) {
      toast.success(response.data.message);
      getMyProfile(api.profile);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const cancelSubscription = async (id) => {
    setLoading(true);
    let form = JSON.stringify({
      subscriptionId: id,
    });
    const response = await ApiService.postAPIWithAccessToken(
      api.subscriptionCancel,
      form
    );
    setCancelPlan({
      status: false,
      id: null,
    });
    if (response.data.status && response.data.statusCode === 200) {
      getMyProfile(api.profile);
      toast.success(response.data.message);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const deleteAccount = async () => {
    setLoading(true);
    const response = await ApiService.deleteAPIWithAccessToken(
      api.deleteAccount
    );
    setDeleteAcc(false);
    if (response.data.status) {
      toast.success(response.data.message);
      signOut();
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  function findCategory(id) {
    for (let i in categories) {
      if (categories[i].name == id) {
        return categories[i].id;
      }
    }
    return null;
  }

  const { isLoaded } = useJsApiLoader({
    id: "google-map-script",
    googleMapsApiKey: GeolocationApiKey,
    libraries: ["places"],
  });

  const handlePlaceChange = (setFieldValue) => {
    let [address] = inputRef.current.getPlaces();
    // console.log(findStateCity('administrative_area_level_1', address.address_components));
    // console.log(findStateCity('locality', address.address_components));
    setLocation({
      lat: address.geometry.location.lat(),
      lng: address.geometry.location.lng(),
      address: address.formatted_address,
    });
    setFieldValue("address", address.formatted_address);
  };

  const updateProfileImg = async (formvalue) => {
    setLoading(true);
    let form = new FormData();
    form.append("image", formvalue.image);
    const response = await ApiService.postAPIWithAccessTokenMultiPart(
      api.updateProfileImage,
      form
    );
    setEditImg(false);
    if (response.data.status) {
      toast.success(response.data.message);
      getMyProfile(api.profile);
    } else {
      toast.error(response.data.message);
    }
    setLoading(false);
  };

  const signOut = useCallback(() => {
    dispatch(userLogout());
  }, [dispatch]);

  const handleFileChange = (event, setFieldValue) => {
    const files = Array.from(event.target.files);
    if (files.length + selectedImages.length > 3) {
      alert("You can upload a maximum of 3 files.");
      return;
    }
    const imageUrls = files.map((file) => ({
      file,
      isLive: false,
      preview: URL.createObjectURL(file),
    }));
    setSelectedImages((prev) => [...prev, ...imageUrls]);
    setFieldValue("files", [...selectedImages, ...imageUrls]);
  };

  const removeImage = (index, setFieldValue, id = null) => {
    if (id != null) {
      const updatedLicenseImages = selectedLicenseImages.filter(
        (_, i) => i !== index
      );
      setSelectedLicenseImages(updatedLicenseImages);
      setSelectedDeleteImages((prev) => [...prev, id]);
    } else {
      const updatedImages = selectedImages.filter((_, i) => i !== index);
      setSelectedImages(updatedImages);
      setFieldValue("files", updatedImages);
    }
  };

  useEffect(() => {
    getMyProfile(api.profile);
    getStateList(api.stateList + `?country_id=231`);
    getCategoryList(api.categoryList);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  useEffect(() => {
    getCitiesList();
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, [selectedState]);

  useEffect(() => {
    const careexchange = JSON.parse(localStorage.getItem("careexchange"));
    const completed = careexchange?.provider_profile_completed;
    // if (completed === 0 || completed === null) {
    //   setEdit({ status: true, id: details?.id ?? null });
    // }
  }, [details]);

  return (
    <>
      {loading ? <Loader /> : null}
      <div className="container">
        <div className="messages-section">
          <div className="row">
            <div className="col-md-12">
              <div className="care-title-header">
                <div className="d-flex">
                  <div className="user-profile-media">
                    {details?.logo !== null &&
                      details?.logo !== "" &&
                      details?.logo !== undefined ? (
                      <img src={details?.logo} alt="" />
                    ) : (
                      <img src={NoImage} alt="" />
                    )}
                  </div>
                  <div className="care-title-header-1">
                    <h6 className="heading-name-title text-capitalize p-0">
                      Hello, {details?.business_name ?? "NA"}
                    </h6>
                    <h2 className="heading-title">
                      Your Profile Looks Great !
                    </h2>
                  </div>
                </div>
                <div>
                  <div className="">
                    <Link
                      className="btn-re"
                      onClick={() => setDeleteAcc(true)}
                      to=""
                    >
                      <i className="fa fa-trash ms-2"></i> Delete Account
                    </Link>
                  </div>
                </div>
              </div>
              <div className="providerProfile-section">
                <div className="user-table-item">
                  <div className="row g-1 align-items-center">
                    <div className="col-md-8">
                      <div className="user-profile-item">
                        <div
                          className="user-profile-media"
                          style={{
                            position: "relative",
                            width: "100px",
                            height: "100px",
                            borderRadius: "0",
                            border: "none",
                          }}
                        >
                          {details?.profile_image !== null &&
                            details?.profile_image !== "" &&
                            details?.profile_image !== undefined ? (
                            <img
                              src={details?.profile_image}
                              style={{
                                borderRadius: "50%",
                              }}
                              alt=""
                            />
                          ) : (
                            <img
                              src={NoImage}
                              alt=""
                              style={{
                                borderRadius: "50%",
                              }}
                            />
                          )}
                          <div
                            className="p-image"
                            onClick={() => setEditImg(true)}
                          >
                            <i className="fa fa-pencil"></i>
                          </div>
                        </div>
                        <div className="user-profile-text">
                          <h2 className="text-capitalize">
                            {details?.fullname ?? "NA"}
                          </h2>
                          <div className="d-flex">
                            <div className="email-text text-lowercase">
                              <i className="fa fa-envelope ms-2"></i>{" "}
                              {details?.email ?? "NA"}
                            </div>
                            <div className="email-text ms-3">
                              <i className="fa fa-phone ms-2"></i>{" "}
                              {details?.mobile}
                            </div>
                          </div>
                        </div>
                      </div>
                    </div>
                    <div className="col-md-4">
                      <div className="user-profile-action">
                        <Link
                          className="btn-gr"
                          onClick={() =>
                            setEdit({ status: true, id: details?.id })
                          }
                        >
                          <i className="fa fa-edit ms-2"></i> Edit Profile
                        </Link>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="providerprofile-overview">
                  <div className="row g-3">
                    <div className="col-md-4">
                      <div className="overview-card">
                        <div className="overview-content">
                          <h2>Category</h2>
                          <h4 style={{ fontSize: "0.9rem" }}>
                            {details?.category ?? 0}
                          </h4>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="overview-card">
                        <div className="overview-content">
                          <h2>Sub Category</h2>
                          <h4 style={{ fontSize: "0.9rem" }}>
                            {details?.subcategory ?? 0}
                          </h4>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="overview-card">
                        <div className="overview-content">
                          <h2>Service Offered Area</h2>
                          <h4 style={{ fontSize: "0.9rem" }}>
                            {details?.service_offered_area ?? 0} Miles
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="providerprofile-overview">
                  <div className="row g-3">
                    <div className="col-md-4">
                      <div className="overview-card">
                        <div className="overview-content">
                          <h2>Ongoing Jobs</h2>
                          <h4>
                            <Link
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(routes.myJobs, {
                                  state: {
                                    tab: 2,
                                  },
                                });
                              }}
                            >
                              {details?.activeJob ?? 0}
                            </Link>
                          </h4>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="overview-card">
                        <div className="overview-content">
                          <h2>Pending Request</h2>
                          <h4>
                            <Link
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(routes.myJobs, {
                                  state: {
                                    tab: 1,
                                  },
                                });
                              }}
                            >
                              {details?.pendingJob ?? 0}
                            </Link>
                          </h4>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="overview-card">
                        <div className="overview-content">
                          <h2>Cancelled Jobs</h2>
                          <h4>
                            <Link
                              to=""
                              onClick={(e) => {
                                e.preventDefault();
                                navigate(routes.myJobs, {
                                  state: {
                                    tab: 3,
                                  },
                                });
                              }}
                            >
                              {details?.cancellJob ?? 0}
                            </Link>
                          </h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                <div className="providerprofile-overview">
                  <div className="row g-3">
                    <div className="col-md-4">
                      <div className="overview-card">
                        <div className="overview-content">
                          <h2>Repeat Client</h2>
                          <h4>{details?.repeatClient ?? 0}</h4>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="overview-card">
                        <div className="overview-content">
                          <h2>Response Rate</h2>
                          <h4>{details?.responseRate ?? 0}</h4>
                        </div>
                      </div>
                    </div>

                    <div className="col-md-4">
                      <div className="overview-card">
                        <div className="overview-content">
                          <h2>Response Time</h2>
                          <h4>{details?.response_time ?? 0}</h4>
                        </div>
                      </div>
                    </div>
                  </div>
                </div>

                {details?.currentPlan?.length !== 0
                  ? details?.currentPlan?.map((ele, indx) => {
                    return (
                      <div key={indx}>
                        <div className="providerprofile-about d-flex justify-content-between align-items-center">
                          <div className="d-flex align-items-center">
                            <img
                              className="me-3"
                              src={caresuccessful}
                              alt=""
                            />
                            <h2 className="m-0">{ele.name ?? "NA"}</h2>
                          </div>
                          {ele.monthly_commit == "0.00" ? (
                            <div>
                              {/* <Link
                                  className="btn-plan mx-2"
                                  to={routes.subscriptionPlan}
                                >
                                  ${ele.wallet_balance} Wallet Balance
                                </Link>
                                <Link
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setCancelPlan({
                                      status: true,
                                      id: ele.subscriptionId,
                                    });
                                  }}
                                  className="btn-re"
                                >
                                  Cancel Plan
                                </Link> */}
                            </div>
                          ) : (
                            <>
                              <div style={{ color: "#000" }}>
                                <p>
                                  <b>
                                    Next Billing : {ele.nextbilling ?? "NA"}
                                  </b>{" "}
                                </p>
                              </div>
                              <div>
                                <Link
                                  className="btn-plan mx-2"
                                  to={routes.subscriptionPlan}
                                >
                                  ${ele.amount}/{ele.plan_type}
                                </Link>
                                <Link
                                  onClick={(e) => {
                                    e.preventDefault();
                                    setCancelPlan({
                                      status: true,
                                      id: ele.subscriptionId,
                                    });
                                  }}
                                  className="btn-re"
                                >
                                  Cancel Plan
                                </Link>
                              </div>
                            </>
                          )}
                        </div>
                      </div>
                    );
                  })
                  : null}

                <div className="Address-card">
                  <div className="row mt-3">
                    <div className="care-location-text col-md-4">
                      <h4>Payment Types Accepted</h4>
                      <p>{details?.payment_accepted_type ?? "NA"}</p>
                    </div>
                    <div className="care-location-text col-md-4">
                      <h4>Experience </h4>
                      <p>{details?.experience ?? 0} Years</p>
                    </div>
                    <div className="care-location-text col-md-4">
                      <h4>Slogan </h4>
                      <p>{details?.slogan ?? "NA"}</p>
                    </div>
                  </div>
                  <div className="divider col-md-12"></div>
                  <div className="row mt-3">
                    <div className="care-location-text col-md-4">
                      <h4>Fees Per Hour</h4>
                      <p>
                        {details?.currency ?? "$"}
                        {details?.fee_per_hour ?? "0"}
                      </p>
                    </div>
                    <div className="care-location-text col-md-4">
                      <h4>Fees Per Week</h4>
                      <p>
                        {details?.currency ?? "$"}
                        {details?.fee_per_week ?? "0"}
                      </p>
                    </div>
                    <div className="care-location-text col-md-4">
                      <h4>Fees Per Month</h4>
                      <p>
                        {details?.currency ?? "$"}
                        {details?.fee_per_month ?? "0"}
                      </p>
                    </div>
                  </div>
                  <div className="divider col-md-12"></div>
                  <div className="row mt-3">
                    <div className="care-location-text col-md-5">
                      <h4>States</h4>
                      {details?.providerStates?.length !== 0
                        ? details?.providerStates?.map((ele, indx) => {
                          return (
                            <div
                              key={indx}
                              className="strip-text text-capitalize"
                              style={{ marginRight: "4px" }}
                            >
                              {ele.name ?? "NA"}
                            </div>
                          );
                        })
                        : null}
                    </div>
                    <div className="care-location-text col-md-7">
                      <h4>Cities</h4>
                      {details?.providerCities?.length !== 0
                        ? details?.providerCities?.map((ele, indx) => {
                          return (
                            <div
                              key={indx}
                              className="strip-text text-capitalize"
                              style={{ marginRight: "4px" }}
                            >
                              {ele.name ?? "NA"}
                            </div>
                          );
                        })
                        : null}
                    </div>
                  </div>
                  <div className="divider col-md-12"></div>
                  <div className="care-location-text">
                    <h4>Services Description</h4>
                    <p>{details?.description ?? "NA"}</p>
                  </div>
                  <div className="divider col-md-12"></div>
                  <div className="care-location-text mb-2">
                    <h4>Service Area</h4>
                  </div>
                  <div className="full-address-detail">
                    <img src={googlemapIcon} alt="" />
                    <h6>{details?.business_address ?? "NA"}</h6>
                  </div>
                </div>

                {details?.license_images?.length != 0 ? (
                  <div className="Address-card">
                    <div className="row mt-3">
                      <div className="care-location-text col-md-4">
                        <h4>License Image/File</h4>
                      </div>
                    </div>
                    <div className="row p-3">
                      {details?.license_images?.map((ele, indx) => {
                        return (
                          <div
                            key={indx}
                            className="col-md-1 d-flex flex-column align-items-center"
                          >
                            <div>
                              <Link to={ele.url} target="_blank">
                                <img
                                  style={{
                                    maxWidth: "80px",
                                    maxHeight: "80px",
                                  }}
                                  src={FileImg}
                                  alt=""
                                />
                              </Link>
                            </div>
                          </div>
                        );
                      })}
                    </div>
                  </div>
                ) : null}
              </div>
            </div>
          </div>
        </div>
      </div>

      <Modal
        show={edit.status}
        onHide={() => {
          setEdit({
            status: false,
            id: null,
          });
        }}
        className="modal-lg"
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Edit Profile</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <Formik
                initialValues={initialValues}
                validateOnChange={true}
                validationSchema={validationSchema}
                onSubmit={updateProfile}
                enableReinitialize
              >
                {({ values, setFieldValue }) => (
                  <Form>
                    <div className="row findcare-form">
                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>Name</h4>
                          <Field
                            type="text"
                            className="form-control todo-list-input"
                            name="name"
                            placeholder="Enter Name"
                          />
                          <ErrorMessage
                            name="name"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>Email Address</h4>
                          <input
                            type="text"
                            className="form-control todo-list-input"
                            name="email"
                            value={details?.email}
                            disabled
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>Phone</h4>
                          <Field name="phone">
                            {({ field }) => (
                              <InputMask
                                {...field}
                                mask="(999) 999-9999"
                                className="form-control"
                                maskChar=""
                                onChange={(e) => {
                                  setFieldValue(field.name, e.target.value);
                                }}
                                placeholder="Enter phone"
                              />
                            )}
                          </Field>
                          <ErrorMessage
                            name="phone"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group search-form-group mb-1">
                          <h4>Service Area</h4>
                          {isLoaded && (
                            <StandaloneSearchBox
                              onLoad={(ref) => (inputRef.current = ref)}
                              onPlacesChanged={() =>
                                handlePlaceChange(setFieldValue)
                              }
                            >
                              <input
                                className="form-control"
                                placeholder="Enter Service Area"
                                defaultValue={location.address}
                              />
                            </StandaloneSearchBox>
                          )}
                          <span className="form-group-icon">
                            <img src={googlemapIcon} alt="" />
                          </span>
                        </div>
                        <ErrorMessage
                          name="address"
                          component="div"
                          className="alert alert-danger"
                        />
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <h4>Search By Miles Away</h4>
                          <div className="choosemiles-list">
                            <ul>
                              {milesOptions.map((ele, indx) => {
                                return (
                                  <li key={indx}>
                                    <div className="ceradio1">
                                      <Field
                                        type="radio"
                                        name="radius"
                                        id={`${ele.value}miles`}
                                        value={ele.value}
                                      />
                                      <label for={`${ele.value}miles`}>
                                        <span className="checkbox-text">
                                          <img src={LocImg} alt="" /> {ele.label}{" "}
                                        </span>
                                      </label>
                                    </div>
                                  </li>
                                );
                              })}
                            </ul>
                            <ErrorMessage
                              name="radius"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>States</h4>
                          <Select
                            name="state_ids"
                            className="form-control text-capitalize todo-list-input"
                            placeholder="Select states"
                            isMulti={true}
                            defaultValue={editState}
                            options={state}
                            onChange={(ans) => {
                              setSelectedState(ans);
                            }}
                          />
                          {stateError && (
                            <div className="alert alert-danger">
                              State is required!
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>Cities</h4>
                          <Select
                            name="city_ids"
                            className="form-control text-capitalize todo-list-input"
                            placeholder="Select cities"
                            isMulti={true}
                            defaultValue={editCity}
                            options={city}
                            onChange={(ans) => {
                              setSelectedCity(ans);
                            }}
                          />
                          {cityError && (
                            <div className="alert alert-danger">
                              City is required!
                            </div>
                          )}
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>Category</h4>
                          <Field name="category">
                            {({ field }) => (
                              <select
                                {...field}
                                className="form-control"
                                value={selectCategories}
                                onChange={(e) => {
                                  setFieldValue(field.name, e.target.value);
                                  getSubCategoryList(e.target.value);
                                  setSelectCategory(e.target.value);
                                }}
                              >
                                <option value="">Select Category</option>
                                {categories.length !== 0
                                  ? categories.map((ele, indx) => {
                                    return (
                                      <option key={indx} value={ele.id}>
                                        {ele.name ?? "NA"}
                                      </option>
                                    );
                                  })
                                  : null}
                              </select>
                            )}
                          </Field>
                          <ErrorMessage
                            name="category"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>Sub Category</h4>
                          <Field
                            as="select"
                            type="text"
                            className="form-control"
                            name="sub_category"
                          >
                            <option value="">Select Sub Category</option>
                            {subCategories.length !== 0
                              ? subCategories.map((ele, indx) => {
                                return (
                                  <option key={indx} value={ele.id}>
                                    {ele.name ?? "NA"}
                                  </option>
                                );
                              })
                              : null}
                          </Field>
                          <ErrorMessage
                            name="sub_category"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>Free In-Home Assessment Offered?</h4>
                          <div className="choosemiles-list">
                            <ul>
                              <li>
                                <div className="ceradio">
                                  <Field
                                    type="radio"
                                    name="free_in_home_assessment"
                                    id="Yes"
                                    value="1"
                                  />
                                  <label for="Yes">
                                    <span className="checkbox-text"> Yes</span>
                                  </label>
                                </div>
                              </li>
                              <li>
                                <div className="ceradio">
                                  <Field
                                    type="radio"
                                    name="free_in_home_assessment"
                                    id="No"
                                    value="0"
                                  />
                                  <label for="No">
                                    <span className="checkbox-text">No</span>
                                  </label>
                                </div>
                              </li>
                            </ul>
                            <ErrorMessage
                              name="free_in_home_assessment"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>Business Name</h4>
                          <Field
                            type="text"
                            className="form-control"
                            name="business_name"
                            placeholder="Business Name"
                          />
                          <ErrorMessage
                            name="business_name"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>
                            Experience{" "}
                            <span
                              className="text-danger"
                              style={{ fontSize: "0.7rem" }}
                            >
                              (In Years)
                            </span>
                          </h4>
                          <Field
                            type="text"
                            className="form-control"
                            name="experience"
                            placeholder="Enter Experience (In Years)"
                          />
                          <ErrorMessage
                            name="experience"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>Slogan</h4>
                          <Field
                            type="text"
                            className="form-control"
                            name="slogan"
                            placeholder="Enter Slogan"
                          />
                          <ErrorMessage
                            name="slogan"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group search-form-group-r PerHour-form-group">
                          <h4>Fees Per Hour</h4>
                          <Field
                            type="number"
                            className="form-control"
                            name="fee_per_hour"
                            placeholder="$0.00 per hour"
                          />
                          <span className="dollar-text">$</span>
                          <span className="Rangedays-text">/Hour</span>
                        </div>
                        <ErrorMessage
                          name="fee_per_hour"
                          component="div"
                          className="alert alert-danger"
                        />
                      </div>
                      <div className="col-md-6">
                        <div className="form-group search-form-group-r PerHour-form-group">
                          <h4>Fees Per Week</h4>
                          <Field
                            type="number"
                            className="form-control"
                            name="fee_per_week"
                            placeholder="$0.00 per week"
                          />
                          <span className="dollar-text">$</span>
                          <span className="Rangedays-text">/Week</span>
                        </div>
                        <ErrorMessage
                          name="fee_per_week"
                          component="div"
                          className="alert alert-danger"
                        />
                      </div>
                      <div className="col-md-6">
                        <div className="form-group search-form-group-r PerHour-form-group">
                          <h4>Fees Per Month</h4>
                          <Field
                            type="number"
                            className="form-control"
                            name="fee_per_month"
                            placeholder="$0.00 per month"
                          />
                          <span className="dollar-text">$</span>
                          <span className="Rangedays-text">/Month</span>
                        </div>
                        <ErrorMessage
                          name="fee_per_month"
                          component="div"
                          className="alert alert-danger"
                        />
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>
                            Business Logo{" "}
                            <span
                              className="text-danger"
                              style={{ fontSize: "0.7rem" }}
                            >
                              (In JPG, JPEG, PNG)
                            </span>
                          </h4>
                          <Field name="image">
                            {({ field, form }) => (
                              <input
                                type="file"
                                accept="image/jpg, image/jpeg, image/png"
                                className="form-control"
                                onChange={(event) =>
                                  setFieldValue("image", event.target.files[0])
                                }
                              />
                            )}
                          </Field>
                          <ErrorMessage
                            name="image"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>Response Time</h4>
                          <Field
                            as="select"
                            type="text"
                            className="form-control"
                            name="response_time"
                          >
                            <option value="">Select Response Time</option>
                            <option value="30 Minute">30 Minute</option>
                            <option value="1 Hour">1 Hour</option>
                            <option value="2 Hours">2 Hours</option>
                            <option value="3 Hours">3 Hours</option>
                            <option value="5 Hours">5 Hours</option>
                          </Field>
                          <ErrorMessage
                            name="response_time"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-6">
                        <div className="form-group">
                          <h4>License Number</h4>
                          <Field
                            type="number"
                            className="form-control"
                            name="license_number"
                            placeholder="Enter License Number"
                          />
                          <ErrorMessage
                            name="license_number"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <h4>
                            License Image/File{" "}
                            <span
                              className="text-danger"
                              style={{ fontSize: "0.7rem" }}
                            >
                              (In JPG, JPEG, PNG, PDF & DOCX)
                            </span>
                          </h4>
                          <Field name="files">
                            {({ field, form }) => (
                              <div>
                                <input
                                  type="file"
                                  multiple
                                  accept="image/jpg, image/jpeg, image/png, application/pdf, .docx"
                                  className="form-control"
                                  onChange={(event) =>
                                    handleFileChange(event, setFieldValue)
                                  }
                                />
                              </div>
                            )}
                          </Field>
                          <ErrorMessage
                            name="files"
                            component="div"
                            className="alert alert-danger"
                          />
                        </div>
                        <div className="row mb-3">
                          {selectedLicenseImages.map((img, index) => (
                            <div
                              key={index}
                              className="col-md-1 d-flex flex-column align-items-center"
                            >
                              <div>
                                <Link to={img.preview} target="_blank">
                                  <img
                                    style={{
                                      maxWidth: "80px",
                                      maxHeight: "80px",
                                    }}
                                    src={FileImg}
                                    alt=""
                                  />
                                </Link>
                              </div>
                              <div>
                                <Link
                                  to=""
                                  className="delete-btn"
                                  onClick={() => {
                                    removeImage(
                                      index,
                                      setFieldValue,
                                      img.file.id ?? null
                                    );
                                  }}
                                >
                                  <img src={TrashImg} alt="" />
                                </Link>
                              </div>
                            </div>
                          ))}
                          {selectedImages.map((img, index) => (
                            <div
                              key={index}
                              className="col-md-1 d-flex flex-column align-items-center"
                            >
                              <div>
                                <Link to={img.preview} target="_blank">
                                  <img
                                    style={{
                                      maxWidth: "80px",
                                      maxHeight: "80px",
                                    }}
                                    src={FileImg}
                                    alt=""
                                  />
                                </Link>
                              </div>
                              <div>
                                <Link
                                  to=""
                                  className="delete-btn"
                                  onClick={() => {
                                    removeImage(index, setFieldValue);
                                  }}
                                >
                                  <img src={TrashImg} alt="" />
                                </Link>
                              </div>
                            </div>
                          ))}
                        </div>
                      </div>
                      <div className="col-md-12">
                        <div className="form-group">
                          <h4>Payment Types Accepted</h4>
                          <div className="choosemiles-list">
                            <ul>
                              <li>
                                <div className="ceradio1">
                                  <Field
                                    type="radio"
                                    name="payment_accepted_type"
                                    id="FirstPay"
                                    value="Private Pay"
                                  />
                                  <label for="FirstPay">
                                    <span className="checkbox-text">
                                      {" "}
                                      Private Pay
                                    </span>
                                  </label>
                                </div>
                              </li>
                              <li>
                                <div className="ceradio1">
                                  <Field
                                    type="radio"
                                    name="payment_accepted_type"
                                    id="SecondPay"
                                    value="Debit Card"
                                  />
                                  <label for="SecondPay">
                                    <span className="checkbox-text">
                                      Debit Card
                                    </span>
                                  </label>
                                </div>
                              </li>

                              <li>
                                <div className="ceradio1">
                                  <Field
                                    type="radio"
                                    name="payment_accepted_type"
                                    id="ThirdPay"
                                    value="Insurance"
                                  />
                                  <label for="ThirdPay">
                                    <span className="checkbox-text">
                                      Insurance
                                    </span>
                                  </label>
                                </div>
                              </li>

                              <li>
                                <div className="ceradio1">
                                  <Field
                                    type="radio"
                                    name="payment_accepted_type"
                                    id="FourthPay"
                                    value="Stripe"
                                  />
                                  <label for="FourthPay">
                                    <span className="checkbox-text">
                                      Stripe
                                    </span>
                                  </label>
                                </div>
                              </li>

                              <li>
                                <div className="ceradio1">
                                  <Field
                                    type="radio"
                                    name="payment_accepted_type"
                                    id="FifthPay"
                                    value="Medicare/Medicaid"
                                  />
                                  <label for="FifthPay">
                                    <span className="checkbox-text">
                                      Medicare/Medicaid
                                    </span>
                                  </label>
                                </div>
                              </li>
                            </ul>
                            <ErrorMessage
                              name="payment_accepted_type"
                              component="div"
                              className="alert alert-danger"
                            />
                          </div>
                        </div>
                      </div>

                      <div className="form-group">
                        <h4>Services Description</h4>
                        <Field
                          type="text"
                          as="textarea"
                          className="form-control"
                          name="description"
                          placeholder="Services Description"
                        />
                        <ErrorMessage
                          name="description"
                          component="div"
                          className="alert alert-danger"
                        />
                      </div>
                    </div>

                    <div className="form-group text-end">
                      <button
                        type="button"
                        onClick={() => {
                          setEdit({
                            status: false,
                            id: null,
                          });
                        }}
                        className="btn btn-re me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-gr me-2"
                        data-bs-dismiss="modal"
                      >
                        Update
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={deleteAcc}
        onHide={() => {
          setDeleteAcc(false);
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-Img">
                <img src={deleteaccountImg} alt="" />
              </div>
              <div className="deleteaccount-text mb-4">
                <h5 className="text-center pb-0">Delete Account</h5>
                <p className="text-center">
                  This action can't be undone. Do you really want to delete your
                  account ?
                </p>
              </div>
              <div className="form-group text-center mb-2">
                <button
                  type="button"
                  onClick={() => setDeleteAcc(false)}
                  className="btn-wh-re me-2"
                  data-bs-dismiss="modal"
                >
                  Cancel
                </button>
                <button
                  type="submit"
                  className="btn-re"
                  data-bs-dismiss="modal"
                  onClick={() => deleteAccount()}
                >
                  Yes! Delete
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={cancelPlan.status}
        onHide={() => {
          setCancelPlan({
            status: false,
            id: null,
          });
        }}
        className="cc-modal-form"
      >
        <div className="modal-content">
          <ModalBody className="">
            <div className="add-items d-flex row">
              <div className="deleteaccount-Img">
                <img src={deleteaccountImg} alt="" />
              </div>
              <div className="deleteaccount-text mb-4">
                <h5 className="text-center pb-0">Subscription Cancel</h5>
                <p className="text-center">
                  Are you sure you'd like to cancel your subscription ?
                </p>
              </div>
              <div className="form-group text-center mb-0">
                <button
                  type="button"
                  onClick={() =>
                    setCancelPlan({
                      status: false,
                      id: null,
                    })
                  }
                  className="btn-wh-re me-2"
                  data-bs-dismiss="modal"
                >
                  No
                </button>
                <button
                  type="submit"
                  className="btn-re"
                  data-bs-dismiss="modal"
                  onClick={() => cancelSubscription(cancelPlan.id)}
                >
                  Yes
                </button>
              </div>
            </div>
          </ModalBody>
        </div>
      </Modal>

      <Modal
        show={editImg}
        onHide={() => {
          setEditImg(false);
        }}
        className=""
      >
        <div className="modal-content">
          <ModalHeader>
            <h5 className="mb-0">Edit Profile Image</h5>
          </ModalHeader>
          <ModalBody className="">
            <div className="add-items d-flex row">
              <Formik
                initialValues={initialValuesImg}
                validateOnChange={true}
                validationSchema={validationSchemaImg}
                onSubmit={updateProfileImg}
              >
                {({ setFieldValue }) => (
                  <Form>
                    <div className="form-group">
                      <Field name="image">
                        {({ field, form }) => (
                          <input
                            type="file"
                            accept="image/*"
                            className="form-control"
                            onChange={(event) =>
                              setFieldValue(
                                "image",
                                event.currentTarget.files[0]
                              )
                            }
                          />
                        )}
                      </Field>
                      <ErrorMessage
                        name="image"
                        component="div"
                        className="alert alert-danger"
                      />
                    </div>
                    <div className="form-group text-end">
                      <button
                        type="button"
                        onClick={() => {
                          setEditImg(false);
                        }}
                        className="btn btn-re me-2"
                        data-bs-dismiss="modal"
                      >
                        Cancel
                      </button>
                      <button
                        type="submit"
                        className="btn btn-gr me-2"
                        data-bs-dismiss="modal"
                      >
                        Update
                      </button>
                    </div>
                  </Form>
                )}
              </Formik>
            </div>
          </ModalBody>
        </div>
      </Modal>
    </>
  );
};

export default Page;
